import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isWithinRange } from 'date-fns';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import useTruncatedElement from '@medflex/hooks/useTruncatedElement';
import LinkifyText from './LinkifyText';
import Button from './Button';
import InfoBanner, { KINDS } from './InfoBanner/InfoBanner';

const AbsenceInfoBanner = ({ className, startAt, endAt, children }) => {
  const textRef = useRef(null);
  const { t } = useTranslation('global');
  const { isTruncated, isShowingMore, toggleIsShowingMore } = useTruncatedElement(textRef);

  const textCn = classNames([{ 'line-clamp-4': !isShowingMore }, 'whitespace-pre-wrap']);
  const cn = classNames('flex space-x-2', className);

  if (!isWithinRange(Date.now(), startAt, endAt)) {
    return null;
  }

  return (
    <InfoBanner kind={KINDS.INFO} className={cn}>
      <InformationCircleIcon className="w-6 h-6 flex-shrink-0 top-2" />
      <div>
        <div ref={textRef} className={textCn}>
          <LinkifyText>{children}</LinkifyText>
        </div>

        {isTruncated && (
          <Button kind="link" onClick={toggleIsShowingMore}>
            {isShowingMore ? t('read_less') : t('read_more')}
          </Button>
        )}
      </div>
    </InfoBanner>
  );
};

AbsenceInfoBanner.defaultProps = {
  className: '',
};

AbsenceInfoBanner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  startAt: PropTypes.string.isRequired,
  endAt: PropTypes.string.isRequired,
};

export default AbsenceInfoBanner;
